import { lazy } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { QueryCache, QueryClient } from '@tanstack/react-query'

import HomePage from '@/features/home/pages/HomePage'
import Support from '@/features/support'
import ErrorBoundaryPage from '@/routes/ErrorBoundaryPage'
import Layout from '@/shared/components/layout/Layout'

const IntroPage = lazy(() => import('@/features/intro/pages/IntroPage'))
const NoticePage = lazy(() => import('@/features/support/notice/pages/NoticePage'))
const NoticeDetailPage = lazy(() => import('@/features/support/notice/pages/NoticeDetailPage'))
const NewsPage = lazy(() => import('@/features/support/news/pages/NewsPage'))
const FaqPage = lazy(() => import('@/features/support/faq/pages/FaqPage'))
const RefundPage = lazy(() => import('@/features/support/refund/pages/RefundPage'))
const CenterPage = lazy(() => import('@/features/support/center/pages/CenterPage'))
const CancelPage = lazy(() => import('@/features/cancel/pages/CancelPage'))
const TermsPage = lazy(() => import('@/features/terms/TermsPage'))
const AskTermsPage = lazy(() => import('@/features/ask/pages/AskTermsPage'))

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta?.errorMessage) {
        console.warn(query.meta.errorMessage)
        console.warn(error)
      }
    },
  }),
  defaultOptions: { queries: { staleTime: 1000 * 30 } },
})

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorBoundaryPage />,
    children: [
      { index: true, element: <Navigate to="/home" replace /> },
      { path: 'home', element: <HomePage /> },
      { path: 'intro', element: <IntroPage /> },
      {
        element: <Support />,
        children: [
          {
            path: 'notice',
            children: [
              { index: true, element: <NoticePage /> },
              { path: 'detail/:idx', element: <NoticeDetailPage /> },
            ],
          },
          { path: 'faq', element: <FaqPage /> },
          { path: 'center', element: <CenterPage /> },
          { path: 'news', element: <NewsPage /> },
          { path: 'refund', element: <RefundPage /> },
        ],
      },
      { path: 'cancel', element: <CancelPage /> },
      {
        path: 'terms',
        children: [
          { index: true, element: <Navigate to="10/1" replace /> },
          { path: ':telecom/:termsIdx', element: <TermsPage /> },
        ],
      },
    ],
  },
  {
    path: '/ask',
    element: <AskTermsPage />,
  },
])

export default router
